import React, { useEffect, useState } from 'react';
import clinExpertLogo from '../ClinExpert_logo.png';
import '../styles/SplashScreen.css';

const SplashScreen = ({ onComplete, minDuration = 2400 }) => {
    const [fadeOut, setFadeOut] = useState(false);
    const [logoLoaded, setLogoLoaded] = useState(false);

    useEffect(() => {
        const logo = new Image();
        logo.src = clinExpertLogo;
        logo.onload = () => setLogoLoaded(true);

        const fadeTimer = setTimeout(() => setFadeOut(true), Math.max(300, minDuration - 520));
        const doneTimer = setTimeout(() => onComplete?.(), minDuration);

        return () => {
            clearTimeout(fadeTimer);
            clearTimeout(doneTimer);
        };
    }, [minDuration, onComplete]);

    return (
        <div className={`splash-screen ${fadeOut ? 'splash-fade-out' : ''}`}>
            <div className="splash-background-grid" />
            <div className="splash-orb splash-orb-a" />
            <div className="splash-orb splash-orb-b" />
            <div className="splash-content">
                <img
                    src={clinExpertLogo}
                    alt="ClinExpert"
                    className={`splash-logo ${logoLoaded ? 'is-loaded' : ''}`}
                    loading="eager"
                    fetchPriority="high"
                    decoding="async"
                    width="300"
                    height="120"
                />
                <h2 className="splash-portal-title">ClinExpert Portal</h2>
                <p className="splash-subtitle">Clinical Education Platform</p>
                <div className="splash-loader" aria-hidden="true">
                    <span />
                    <span />
                    <span />
                </div>
                <p className="splash-branding">Brought to you by ClinExpert Inc</p>
            </div>
        </div>
    );
};

export default SplashScreen;
